import { Divider as DividerBase } from 'antd';
import { DividerProps } from 'antd/lib/divider';
import React from 'react';

export interface IDividerProps extends DividerProps {
  children?: React.ReactNode;
}

const Divider: React.FC<DividerProps> = ({ children, ...props }) => {
  return <DividerBase {...props}>{children}</DividerBase>;
};

export default Divider;
